import script from "./FlyingTiger-Purchase.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyingTiger-Purchase.vue?vue&type=script&setup=true&lang=js"

import "./FlyingTiger-Purchase.vue?vue&type=style&index=0&id=74327771&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74327771"]])

export default __exports__